module.exports = __webpack_public_path__ + "static/media/statistics.c7cf1e65.jpg";